module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-fotografie"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mazlicek.fotografie.value),
      expression: "!mazlicek.fotografie.value"
    }],
    staticClass: "form-group icn-img-wrapper",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.mazlicek.fotografie.icnValue
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mazlicek.fotografie.value),
      expression: "mazlicek.fotografie.value"
    }],
    staticClass: "form-group crop-img-wrapper",
    staticStyle: {
      "max-width": "1000px"
    }
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": _vm.nechciFotoClick
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', [_c('vue-croppie', {
    ref: "croppieRef",
    attrs: {
      "enableResize": false,
      "viewport": {
        width: _vm.viewportSize,
        height: _vm.viewportSize,
        type: 'square'
      },
      "boundary": {
        width: _vm.boundarySize,
        height: _vm.boundarySize
      }
    }
  })], 1)]), _vm._v(" "), (!_vm.mazlicek.fotografie.value) ? _c('div', {
    staticClass: "fotografie-nahrat"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    ref: "photoInput",
    attrs: {
      "type": "file",
      "id": "file-upload-photo"
    },
    on: {
      "change": _vm.setImage
    }
  })]) : _vm._e()]), _vm._v(" "), _c('info', {
    attrs: {
      "krok": 3
    }
  }), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev,
      "showNext": true,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Profilový obrázek psa"), _c('br'), _vm._v("(bude i na obalu krmiva)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "file-upload-photo"
    }
  }, [_c('span', {
    staticClass: "button"
  }, [_vm._v("Nahrajte vlastní fotku (nepovinné)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e861ff9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/03Fotografie.vue
// module id = 566
// module chunks = 1